import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import { getMetadata } from '../../services/MetadataService';
import { isLargeScreen } from "../../utilities/ScreenView";

const Shark  = () => {
    const trangenames = [
        { label: "srkidx : trg", value: "SRKIDX", }   // 0
    ];

    const trangenamesshort = [
        { label: "srkidx : trg", value: "SRKIDX", }  // 0
    ];        

    const [value, setValue] = useState('')
    const [valuesaved, setValuesaved] = useState('')
    var { name } = useParams();
    name = "shark.index"

    useEffect(() => {
            // const interval = setInterval(() => { listMarketplace(); listAllTickers(); setDate(new Date()); }, 10000)
            const interval = setInterval(() => { listMetadata(); }, 2000)
            return () => {  clearInterval(interval); }
        });

    function listMetadata() {
        getMetadata(name).then((response) => {
            // console.log(response.data)
            setValue(response.data.value)
        }).catch(error => {
            console.log(error);
        })

        if  (isNaN.value)
            { setValue(valuesaved)  }
        else { setValuesaved(value)  }
    }
    
    function getSharkName(idx) {
        return trangenames[idx].label;
    }

    function getSharkNameShort(idx) {
        return trangenamesshort[idx].label;
    }

    function showSharkPercent(idx) {

        var percent = parseFloat(value).toFixed(2);  // shark index [SRKIDX]

        if (percent === 0.0) return <td style={{ fontSize: 'small' }} className="col col-lg-1 text-secondary text-center">&nbsp;&nbsp;0.00%</td>
        if (percent === '0.00') return <td style={{ fontSize: 'small' }} className="col col-lg-1 text-secondary text-center">&nbsp;&nbsp;{percent}%</td>

        if (percent > 0 && percent < 10) return <td style={{ fontSize: 'small' }} className="col col-lg-1 text-center">&nbsp;&nbsp;{percent}%</td>
        if (percent > 9.99 && percent < 20) return <td style={{ fontSize: 'small', backgroundColor: '#fffff0' }} className="col col-lg-1 text-center">{percent}%</td>
        if (percent > 19.99 && percent < 50) return <td style={{ fontSize: 'small', backgroundColor: '#ffff99' }} className="col col-lg-1 text-center">{percent}%</td>
        if (percent > 49.99 && percent < 80) return <td style={{ fontSize: 'small', backgroundColor: '#ff8080' }} className="col col-lg-1 text-center">{percent}%</td>
        if (percent > 79.99) return <td style={{ fontSize: 'small', backgroundColor: '#cc33ff' }} className="col col-lg-1 text-center">{percent}%</td>
        
        return <td style={{ fontSize: 'small', color: 'black' }} className="col col-lg-1 text-center">&nbsp;</td>
    }

    function showShark() {
            return (
                <>
                { isLargeScreen() ? 
                    <div style={{paddingLeft: '0px' }} className="col-sm-12">
                        <span className="sp-ot">Shark IDX</span>
                        <table className="border border-light border-1 table-sm">
                            <tbody>
                                <tr style={{ backgroundColor: '#fcedff'}} className="text-secondary">
                                    <td style={{ fontSize: 'small' }} className="col col-lg-1 text-secondary text-center">{getSharkName(0)}</td>
                                    {showSharkPercent(0)}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                :
                    <div style={{paddingTop: '20px' }} className="col-sm-7">
                        <span className="sp-ot">Shark IDX</span>
                        <table className="border border-light border-1 table-sm">
                            <tbody>
                                <tr style={{ backgroundColor: '#f7f7f7'}} className="text-secondary">
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getSharkNameShort(0)}</td>
                                    {showSharkPercent(0)}
                                </tr>                            
                            </tbody>
                        </table>
                    </div>
                }
            </>
        )
    }

    function showSpinner() {
        return (
            <>
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </>
        )
    }

    return (
        <>
            { !isNaN.value ? showShark() :  showSpinner() }
        </>
    )
}

export default Shark